import { useConst } from '@chakra-ui/react';
import Raw_materials_listing_component from './product_listing_component';
import { useContext } from 'react';
import { Home_context } from '../../context/home_context';

export default function Raw_product_listing() {
    const dummy_data=[
        {
      "name": "Sodium Lauryl Sulfate (SLS)",
      "supplier": "Stepan",
      "inci_name": "Sodium Lauryl Sulfate",
      "description": "A common anionic surfactant known for its strong cleaning power.  Can be harsh for some individuals.",
      "link": "https://www.stepan.com/"
    },
    {
      "name": "Sodium Laureth Sulfate (SLES)",
      "supplier": "Evonik",
      "inci_name": "Sodium Laureth Sulfate",
      "description": "A milder anionic surfactant than SLS, also a strong cleaner but less irritating.",
      "link": "https://www.evonik.com/"
    },
    {
      "name": "Cocamidopropyl Betaine",
      "supplier": "BASF",
      "inci_name": "Cocamidopropyl Betaine",
      "description": "A zwitterionic surfactant, milder than SLS and SLES, often used as a secondary surfactant to improve mildness and foam.",
      "link": "https://www.basf.com/"
    },
    {
      "name": "Coco-Glucoside",
      "supplier": "Cognis (now part of BASF)",
      "inci_name": "Coco-Glucoside",
      "description": "A nonionic surfactant derived from coconut and glucose, known for its mildness and biodegradability.",
      "link": "https://www.basf.com/"
    },
    {
      "name": "Cetyl Alcohol",
      "supplier": "Croda",
      "inci_name": "Cetyl Alcohol",
      "description": "A fatty alcohol that acts as a conditioning agent, providing slip and emollience.",
      "link": "https://www.croda.com/"
    },
    {
      "name": "Stearyl Alcohol",
      "supplier": "Sasol",
      "inci_name": "Stearyl Alcohol",
      "description": "Similar to cetyl alcohol, another fatty alcohol used as a conditioning agent.",
      "link": "https://www.sasol.com/"
    },
    {
      "name": "Behentrimonium Chloride",
      "supplier": "AkzoNobel",
      "inci_name": "Behentrimonium Chloride",
      "description": "A cationic conditioning agent that provides softness and detangling properties.",
      "link": "https://www.akzonobel.com/"
    },
    {
      "name": "Panthenol",
      "supplier": "BASF",
      "inci_name": "Panthenol",
      "description": "A provitamin B5, known for its moisturizing and conditioning properties.",
      "link": "https://www.basf.com/"
    },
    {
      "name": "Glycerin",
      "supplier": "Numerous Suppliers",
      "inci_name": "Glycerin",
      "description": "A humectant that attracts and retains moisture, improving skin and hair hydration.",
      "link": "https://www.ulprospector.com/en/asia/PersonalCare/Product?st=1&q=Glycerin"
    }
]
const {Suggestion_data_state}=useContext(Home_context)
  return (
    <>
      {true &&
        Suggestion_data_state?.Suggestion_data?.map((el) => {
          return (
            <Raw_materials_listing_component
              name={el?.rm_name}
              el={el}
              // supplier={el?.supplier}
              inci_name={el?.rm_name_en}
              description={el?.presentation_en}
              link={el?.link}
            />
          );
        })}
    </>
  );
}
